import React from 'react';

import { Spacing, Text, Title } from '@vkontakte/vkui';
import { AnimatePresence, motion } from 'framer-motion';

import styles from './index.module.css';
import { ResultProps } from './types';

export const Result: React.FC<ResultProps> = ({ title, temperamentData }) => {
  return (
    <div>
      <div className={styles.upperTextContainer}>
        <Text className={styles.subTitle}>
          Результаты готовы!
        </Text>
        <Title level="2" weight="2" className={styles.title}>
          {title}
        </Title>
      </div>
      <Spacing size={12} />
      <div className={styles.content}>
        <AnimatePresence>
          <motion.div animate={{ scale: [1, 1.02, 1] }} transition={{ duration: 0.3 }}>
            {temperamentData.image.desktop}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};
